<template>
    <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="w-100">
            <h5>Estimate Payment<button type="button" class="close"
                                      @click.prevent="closeModal()">
                <span aria-hidden="true">&times;</span></button>
            </h5>
        </div>
        <b-form>
            <div class="container-fluid">
                <div class="row justify-content-center m-2">
                    <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
                        <div>{{ generalErrorMessage }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-2">
                    </div>
                    <div class="col-8">
                        <b-form-group id="amountFieldGroup"
                                      horizontal
                                      :label-cols="4"
                                      breakpoint="md"
                                      invalid-feedback="Amount is required"
                                      label="Amount"
                                      label-for="amountField"
                                      label-class="text-right">
                            <b-input-group prepend="$">
                            <b-form-input id="amountField" v-model="payment.amount"></b-form-input>
                            </b-input-group>
                        </b-form-group>

                        <div class="row justify-content-center mb-3">
                          <b-button-group v-if="estimate.hasPaymentToken">
                            <b-button v-bind:class="{ 'btn-hh-white': !isActive(0), 'btn-hh-orange': isActive(0), 'btn-outline-orange': true }" @click.prevent="switchTabs(0)">{{tokenTitle}}</b-button>
                            <b-button v-bind:class="{ 'btn-hh-white': !isActive(1), 'btn-hh-orange': isActive(1), 'btn-outline-orange': true }" @click.prevent="switchTabs(1)">{{cardFormTitle}}</b-button>
                          </b-button-group>
                        </div>
                          <div class="row justify-content-center">
                            <div v-if="estimate.hasPaymentToken && tabIndex === 0"><div style="min-height: 225px;"><center>There is a {{ estimate.cardType }} on file ending in {{ estimate.last4 }}.</center></div></div>
                            <div v-if="!estimate.hasPaymentToken || tabIndex == 1">
                              <div style="min-height: 225px;">
                                <b-form-group id="nameFieldGroup"
                                              horizontal
                                              :label-cols="4"
                                              breakpoint="md"
                                              invalid-feedback="Cardholder Name is required"
                                              label="Cardholder Name"
                                              label-for="nameField"
                                              label-class="text-right">
                                    <b-form-input id="nameField" v-model="payment.cardholderName"></b-form-input>
                                </b-form-group>
                                <b-form-group id="numberFieldGroup"
                                              horizontal
                                              :label-cols="4"
                                              breakpoint="md"
                                              invalid-feedback="Card Number is required"
                                              :valid-feedback="numberValidFeedback"
                                              :state="numberState"
                                              label="Card Number"
                                              label-for="numberField"
                                              label-class="text-right">
                                    <b-form-input id="numberField" v-model="payment.cardNumber"></b-form-input>
                                </b-form-group>
                                <b-form-group id="expirationDateFieldGroup"
                                              horizontal
                                              :label-cols="4"
                                              breakpoint="md"
                                              invalid-feedback="Expiration date is required"
                                              label="Expiration Date"
                                              label-for="expirationDateField"
                                              label-class="text-right">
                                    <b-form-input id="expirationDateField" @input="expirationInput" :value="expirationDateDisplay" placeholder="MM/YY"></b-form-input>
                                </b-form-group>
                                <b-form-group id="cvvFieldGroup"
                                              horizontal
                                              :label-cols="4"
                                              breakpoint="md"
                                              invalid-feedback="Security Code is required"
                                              label="Security Code (CVV)"
                                              label-for="cvvField"
                                              label-class="text-right">
                                    <b-form-input id="cvvField" v-model="payment.cvv"></b-form-input>
                                </b-form-group>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
        </b-form>
        <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-orange float-right" @click.prevent="processPayment()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner"  pulse/>Process</button>
            <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
        </div>
    </b-modal>
</template>

<script>
  import api from '../services/api'
  import cct from 'credit-card-type'
  import ErrorsMixin from '../mixins/ErrorsMixin'
  import moment from 'moment'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'EstimatePaymentModal',

    components: { },

    mixins: [ErrorsMixin, AnalyticsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      estimate: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        payment: {
          cardholderName: '',
          cardNumber: '',
          expirationMonth: 0,
          expirationYear: 0,
          amount: 0,
          cvv: '',
          useCardToken: false
        },
        isSaving: false,
        tabIndex: 0
      }
    },

    watch: {
      estimate (newValue, oldValue) {
        this.clearPaymentData()
        this.setupDefaults()
      },

      visible (newValue) {
        if (newValue) {
          this.setupDefaults()
        } else {
          this.clearPaymentData()
        }
      }
    },

    computed: {
      tokenTitle () {
        if (this.estimate.hasPaymentToken === true) {
          return this.estimate.cardType + ' (' + this.estimate.last4 + ')'
        }

        return ''
      },

      cardFormTitle () {
        if (this.estimate.hasPaymentToken === true) {
          return 'Other Card'
        } else {
          return 'Credit Card'
        }
      },

      expirationDateDisplay () {
        if (this.payment.expirationMonth) {
          if (this.payment.expirationYear.length > 0) {
            return this.payment.expirationMonth + '/' + this.payment.expirationYear
          } else if (this.payment.expirationMonth.length > 1) {
            return this.payment.expirationMonth + '/'
          } else {
            return this.payment.expirationMonth
          }
        }
        return ''
      },

      numberValidFeedback () {
        const cards = cct(this.payment.cardNumber)
        if (cards.length === 1) {
          return cards[0].niceType
        }

        return ''
      },

      numberState () {
        const cards = cct(this.payment.cardNumber)
        if (cards.length === 1) {
          return true
        }

        return null
      }
    },

    methods: {
      isActive (index) {
        if (index === this.tabIndex) {
          return true
        }
        return false
      },

      switchTabs (index) {
        this.tabIndex = index
        if (this.tabIndex === 0) {
          this.payment.useCardToken = true
        } else {
          this.payment.useCardToken = false
        }
      },

      setupDefaults () {
        if (this.estimate.patient) {
          this.payment.cardholderName = this.estimate.patient.firstName + ' ' + this.estimate.patient.lastName
        }
        let patientTotal = this.estimate.patientTotal
        if (this.estimate.patientTotalWithDiscount && moment(this.estimate.discountExpiration).isSameOrAfter(moment.now())) {
          patientTotal = this.estimate.patientTotalWithDiscount
        }

        if (this.estimate.amountPaid) {
          this.payment.amount = (patientTotal - this.estimate.amountPaid).toFixed(2)
        } else {
          this.payment.amount = patientTotal
        }
        this.payment.cardNumber = ''
        this.payment.cvv = ''

        if (this.estimate.hasPaymentToken) {
          this.payment.useCardToken = true
          this.tabIndex = 0
        }
      },

      clearPaymentData () {
        this.payment = {
          name: '',
          cardNumber: '',
          expirationMonth: 0,
          expirationYear: 0,
          amount: 0,
          useCardToken: false
        }
      },

      expirationInput (value) {
        const newDate = value
        const expirationParts = newDate.split('/')
        if (expirationParts.length > 1) {
          this.payment.expirationMonth = expirationParts[0]
          this.payment.expirationYear = expirationParts[1]
        } else {
          this.payment.expirationMonth = expirationParts[0]
        }
      },

      processPayment () {
        if (this.isSaving) {
          return
        }

        this.clearAllErrors()
        let card = ''
        if (!this.useCardToken) {
          card = cct(this.payment.cardNumber)

          if (card.length === 1) {
            card = card[0].niceType
          } else {
            card = 'Unknown'
          }

          card = card.replace(' ', '')
        }

        this.payment.cardType = card

        this.isSaving = true
        this.errorMessage = ''

        api.post('/Dashboard/Estimate/' + this.estimate.organizationPatientEstimateId + '/Payment', this.payment).then(response => {
          this.trackEvent(this.$options.name, 'Save', 'ResponseTime', response.config.requestDuration)

          const payments = response.data
          let allSuccess = true
          for (const payment of payments) {
            if (payment.creditCardPaymentResult !== 'Success') {
              this.trackEvent(this.$options.name, 'PaymentError', payment.hostResponseMessage)
              this.addErrorForField('exception', payment.hostResponseMessage)
              allSuccess = false
            }
          }
          if (allSuccess) {
            this.$emit('paymentProcessed', payments)
          }

        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {

            if (error && error.response && error.response.data) {
              const message = error.response.data.error[0]

              if (message.includes('token') === true) {
                this.setupDefaults()
              }
            }

            this.$store.logErrorResponse(this.$options.name, 'SaveError', error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

.btn-hh-white {
  background-color: white;
  color: #ff4f00;
  border-color: #ff4f00;
}

.btn-hh-orange {
  color: white;
  background-color: #ff4f00 !important;
  border-color:  #ff4f00;
}

.btn:focus {
  outline:none;
  box-shadow: none;
}

</style>
